// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Buscador global de la barra superior ─────────────────────────────────
   Vive en el hueco central del navbar. Todo con variables del design system:
   el panel flota sobre la página, así que usa --bg-surface (opaca) y no
   --bg-card (translúcida en los skins Lumina).                                */

.navbar-gs {
  position: relative;
  flex: 1 1 320px;
  min-width: 190px;
  max-width: 520px;
  display: flex;
  align-items: center;
}

.navbar-gs-box {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  width: 100%;
  height: 38px;
  padding: 0 0.6rem;
  border: 1px solid var(--slate-200);
  border-radius: 10px;
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.navbar-gs-box.is-open,
.navbar-gs-box:focus-within {
  border-color: var(--accent);
  background: var(--bg-input);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.14);
}

.navbar-gs-box.is-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.navbar-gs-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--text-muted);
}

.navbar-gs-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.85rem;
  font-family: inherit;
}

.navbar-gs-input::placeholder {
  color: var(--text-muted);
}

.navbar-gs-clear {
  border: none;
  background: transparent;
  color: var(--text-muted);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 0.15rem;
  border-radius: 6px;
}

.navbar-gs-clear:hover {
  color: var(--text-primary);
  background: var(--slate-200);
}

.navbar-gs-spinner {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid rgba(var(--accent-rgb), 0.25);
  border-top-color: var(--accent);
  animation: navbar-gs-spin 0.7s linear infinite;
}

/* Conmutador «Todas»: amplía la búsqueda a todos los tenants del usuario. */
.navbar-gs-scope {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
  height: 24px;
  padding: 0 0.45rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: transparent;
  color: var(--text-muted);
  font-size: 0.7rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.navbar-gs-scope:hover {
  color: var(--text-primary);
  border-color: var(--accent);
}

.navbar-gs-scope.is-on {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.16);
  color: var(--accent);
}

@keyframes navbar-gs-spin {
  to { transform: rotate(360deg); }
}

/* ── Panel de resultados ─────────────────────────────────────────────── */
.navbar-gs-panel {
  position: absolute;
  top: calc(100% + 0.45rem);
  left: 0;
  width: min(560px, calc(100vw - 1.5rem));
  max-height: min(460px, calc(100vh - 120px));
  display: flex;
  flex-direction: column;
  /* Opaca: el panel flota sobre contenido claro (planos, fichas, mapas). */
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  z-index: 1045;
  animation: navbar-gs-drop 0.16s ease;
}

@keyframes navbar-gs-drop {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.navbar-gs-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.55rem 0.85rem;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(180deg, rgba(var(--accent-rgb), 0.1), transparent);
  color: var(--text-secondary);
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.navbar-gs-head-hint {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  color: var(--text-muted);
}

.navbar-gs-head-scope {
  margin-right: 0.45rem;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: rgba(var(--accent-rgb), 0.16);
  color: var(--accent);
}

.navbar-gs-list {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.navbar-gs-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.55rem 0.85rem;
  border: none;
  border-bottom: 1px solid rgba(148, 163, 184, 0.14);
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s ease;
}

.navbar-gs-item:hover,
.navbar-gs-item.is-active {
  background: rgba(var(--accent-rgb), 0.12);
}

.navbar-gs-item-icon {
  flex-shrink: 0;
  font-size: 1rem;
  width: 20px;
  text-align: center;
}

.navbar-gs-item-body {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
  flex: 1 1;
}

.navbar-gs-item-name {
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-gs-item-meta {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  min-width: 0;
  font-size: 0.76rem;
  color: var(--text-secondary);
}

.navbar-gs-item-type {
  flex-shrink: 0;
  padding: 0 0.35rem;
  border-radius: 5px;
  background: rgba(var(--accent-rgb), 0.14);
  color: var(--accent);
  font-weight: 700;
  white-space: nowrap;
}

.navbar-gs-item-desc {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-muted);
}

/* Empresa del resultado (solo con la búsqueda abierta a todos los tenants).
   Las de OTRA empresa se destacan en color de acento: son las que evitan
   registrar el equipo dos veces. La de la empresa activa va apagada. */
.navbar-gs-item-company {
  flex-shrink: 0;
  max-width: 150px;
  padding: 0 0.45rem;
  border: 1px solid rgba(var(--accent-rgb), 0.35);
  border-radius: 999px;
  background: rgba(var(--accent-rgb), 0.12);
  color: var(--accent);
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-gs-item-company.is-current {
  border-style: dashed;
  border-color: var(--border);
  background: var(--bg-toolbar);
  color: var(--text-muted);
}

.navbar-gs-item-go {
  flex-shrink: 0;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.navbar-gs-foot {
  padding: 0.45rem 0.85rem;
  border-top: 1px solid var(--border);
  color: var(--text-muted);
  font-size: 0.72rem;
}

.navbar-gs-empty {
  padding: 0.95rem 0.85rem;
  color: var(--text-muted);
  font-size: 0.84rem;
}

.navbar-gs-empty.is-error {
  color: #dc2626;
}

/* ── Responsive: en pantallas estrechas el buscador se abre encima ───── */
@media (max-width: 1200px) {
  .navbar-gs { max-width: 340px; }
  .navbar-gs-scope-label { display: none; }
}

@media (max-width: 992px) {
  .navbar-gs { min-width: 140px; flex-basis: 200px; }
  .navbar-gs-panel {
    position: fixed;
    left: 0.5rem;
    right: 0.5rem;
    width: auto;
    top: calc(var(--app-topbar-h, 69px) + 0.35rem);
  }
}

/* Móvil: el campo se reduce a la lupa; al tocarla ocupa todo el ancho. */
@media (max-width: 768px) {
  .navbar-gs {
    flex: 0 0 auto;
    min-width: 0;
    max-width: none;
  }

  .navbar-gs .navbar-gs-box {
    width: 38px;
    padding: 0;
    justify-content: center;
    border-color: transparent;
    background: transparent;
  }

  .navbar-gs .navbar-gs-input,
  .navbar-gs .navbar-gs-clear,
  .navbar-gs .navbar-gs-spinner {
    display: none;
  }

  /* El conmutador «Todas» tampoco cabe en el icono de la lupa. */
  .navbar-gs .navbar-gs-scope {
    display: none;
  }

  .navbar-gs.is-expanded .navbar-gs-scope {
    display: inline-flex;
  }

  .navbar-gs.is-expanded {
    position: absolute;
    left: 0.5rem;
    right: 0.5rem;
    top: 0.5rem;
    z-index: 1050;
    max-width: none;
    flex: 1 1 auto;
  }

  .navbar-gs.is-expanded .navbar-gs-box {
    width: 100%;
    padding: 0 0.6rem;
    justify-content: flex-start;
    border-color: var(--accent);
    background: var(--bg-input);
  }

  .navbar-gs.is-expanded .navbar-gs-input {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GlobalSearch.css"],"names":[],"mappings":"AAAA;;;gFAGgF;;AAEhF;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,iFAAiF;AACnF;;AAEA;;EAEE,2BAA2B;EAC3B,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,+CAA+C;EAC/C,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,uCAAuC;EACvC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,yEAAyE;EACzE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,sCAAsC;EACtC,8EAA8E;EAC9E,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,kDAAkD;EAClD,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;uEAEuE;AACvE;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,oBAAoB;EACpB,yCAAyC;EACzC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,aAAa,gBAAgB,EAAE;EAC/B,yBAAyB,aAAa,EAAE;AAC1C;;AAEA;EACE,aAAa,gBAAgB,EAAE,iBAAiB,EAAE;EAClD;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,WAAW;IACX,8CAA8C;EAChD;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,cAAc;IACd,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;;;IAGE,aAAa;EACf;;EAEA,+DAA+D;EAC/D;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,aAAa;IACb,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ── Buscador global de la barra superior ─────────────────────────────────\r\n   Vive en el hueco central del navbar. Todo con variables del design system:\r\n   el panel flota sobre la página, así que usa --bg-surface (opaca) y no\r\n   --bg-card (translúcida en los skins Lumina).                                */\r\n\r\n.navbar-gs {\r\n  position: relative;\r\n  flex: 1 1 320px;\r\n  min-width: 190px;\r\n  max-width: 520px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.navbar-gs-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  width: 100%;\r\n  height: 38px;\r\n  padding: 0 0.6rem;\r\n  border: 1px solid var(--slate-200);\r\n  border-radius: 10px;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.navbar-gs-box.is-open,\r\n.navbar-gs-box:focus-within {\r\n  border-color: var(--accent);\r\n  background: var(--bg-input);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.14);\r\n}\r\n\r\n.navbar-gs-box.is-disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.navbar-gs-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.navbar-gs-input {\r\n  flex: 1;\r\n  min-width: 0;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  font-size: 0.85rem;\r\n  font-family: inherit;\r\n}\r\n\r\n.navbar-gs-input::placeholder {\r\n  color: var(--text-muted);\r\n}\r\n\r\n.navbar-gs-clear {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  padding: 0 0.15rem;\r\n  border-radius: 6px;\r\n}\r\n\r\n.navbar-gs-clear:hover {\r\n  color: var(--text-primary);\r\n  background: var(--slate-200);\r\n}\r\n\r\n.navbar-gs-spinner {\r\n  width: 13px;\r\n  height: 13px;\r\n  flex-shrink: 0;\r\n  border-radius: 50%;\r\n  border: 2px solid rgba(var(--accent-rgb), 0.25);\r\n  border-top-color: var(--accent);\r\n  animation: navbar-gs-spin 0.7s linear infinite;\r\n}\r\n\r\n/* Conmutador «Todas»: amplía la búsqueda a todos los tenants del usuario. */\r\n.navbar-gs-scope {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  flex-shrink: 0;\r\n  height: 24px;\r\n  padding: 0 0.45rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\r\n}\r\n\r\n.navbar-gs-scope:hover {\r\n  color: var(--text-primary);\r\n  border-color: var(--accent);\r\n}\r\n\r\n.navbar-gs-scope.is-on {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.16);\r\n  color: var(--accent);\r\n}\r\n\r\n@keyframes navbar-gs-spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* ── Panel de resultados ─────────────────────────────────────────────── */\r\n.navbar-gs-panel {\r\n  position: absolute;\r\n  top: calc(100% + 0.45rem);\r\n  left: 0;\r\n  width: min(560px, calc(100vw - 1.5rem));\r\n  max-height: min(460px, calc(100vh - 120px));\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* Opaca: el panel flota sobre contenido claro (planos, fichas, mapas). */\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  box-shadow: var(--shadow-lg);\r\n  overflow: hidden;\r\n  z-index: 1045;\r\n  animation: navbar-gs-drop 0.16s ease;\r\n}\r\n\r\n@keyframes navbar-gs-drop {\r\n  from { opacity: 0; transform: translateY(-6px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.navbar-gs-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n  padding: 0.55rem 0.85rem;\r\n  border-bottom: 1px solid var(--border);\r\n  background: linear-gradient(180deg, rgba(var(--accent-rgb), 0.1), transparent);\r\n  color: var(--text-secondary);\r\n  font-size: 0.74rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.3px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.navbar-gs-head-hint {\r\n  font-weight: 500;\r\n  text-transform: none;\r\n  letter-spacing: 0;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.navbar-gs-head-scope {\r\n  margin-right: 0.45rem;\r\n  padding: 0 0.4rem;\r\n  border-radius: 999px;\r\n  background: rgba(var(--accent-rgb), 0.16);\r\n  color: var(--accent);\r\n}\r\n\r\n.navbar-gs-list {\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.navbar-gs-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  width: 100%;\r\n  padding: 0.55rem 0.85rem;\r\n  border: none;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.14);\r\n  background: transparent;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.navbar-gs-item:hover,\r\n.navbar-gs-item.is-active {\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n}\r\n\r\n.navbar-gs-item-icon {\r\n  flex-shrink: 0;\r\n  font-size: 1rem;\r\n  width: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.navbar-gs-item-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.1rem;\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.navbar-gs-item-name {\r\n  color: var(--text-primary);\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.navbar-gs-item-meta {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 0.4rem;\r\n  min-width: 0;\r\n  font-size: 0.76rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.navbar-gs-item-type {\r\n  flex-shrink: 0;\r\n  padding: 0 0.35rem;\r\n  border-radius: 5px;\r\n  background: rgba(var(--accent-rgb), 0.14);\r\n  color: var(--accent);\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.navbar-gs-item-desc {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* Empresa del resultado (solo con la búsqueda abierta a todos los tenants).\r\n   Las de OTRA empresa se destacan en color de acento: son las que evitan\r\n   registrar el equipo dos veces. La de la empresa activa va apagada. */\r\n.navbar-gs-item-company {\r\n  flex-shrink: 0;\r\n  max-width: 150px;\r\n  padding: 0 0.45rem;\r\n  border: 1px solid rgba(var(--accent-rgb), 0.35);\r\n  border-radius: 999px;\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n  color: var(--accent);\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.navbar-gs-item-company.is-current {\r\n  border-style: dashed;\r\n  border-color: var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n}\r\n\r\n.navbar-gs-item-go {\r\n  flex-shrink: 0;\r\n  color: var(--text-muted);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.navbar-gs-foot {\r\n  padding: 0.45rem 0.85rem;\r\n  border-top: 1px solid var(--border);\r\n  color: var(--text-muted);\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.navbar-gs-empty {\r\n  padding: 0.95rem 0.85rem;\r\n  color: var(--text-muted);\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.navbar-gs-empty.is-error {\r\n  color: #dc2626;\r\n}\r\n\r\n/* ── Responsive: en pantallas estrechas el buscador se abre encima ───── */\r\n@media (max-width: 1200px) {\r\n  .navbar-gs { max-width: 340px; }\r\n  .navbar-gs-scope-label { display: none; }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .navbar-gs { min-width: 140px; flex-basis: 200px; }\r\n  .navbar-gs-panel {\r\n    position: fixed;\r\n    left: 0.5rem;\r\n    right: 0.5rem;\r\n    width: auto;\r\n    top: calc(var(--app-topbar-h, 69px) + 0.35rem);\r\n  }\r\n}\r\n\r\n/* Móvil: el campo se reduce a la lupa; al tocarla ocupa todo el ancho. */\r\n@media (max-width: 768px) {\r\n  .navbar-gs {\r\n    flex: 0 0 auto;\r\n    min-width: 0;\r\n    max-width: none;\r\n  }\r\n\r\n  .navbar-gs .navbar-gs-box {\r\n    width: 38px;\r\n    padding: 0;\r\n    justify-content: center;\r\n    border-color: transparent;\r\n    background: transparent;\r\n  }\r\n\r\n  .navbar-gs .navbar-gs-input,\r\n  .navbar-gs .navbar-gs-clear,\r\n  .navbar-gs .navbar-gs-spinner {\r\n    display: none;\r\n  }\r\n\r\n  /* El conmutador «Todas» tampoco cabe en el icono de la lupa. */\r\n  .navbar-gs .navbar-gs-scope {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-gs.is-expanded .navbar-gs-scope {\r\n    display: inline-flex;\r\n  }\r\n\r\n  .navbar-gs.is-expanded {\r\n    position: absolute;\r\n    left: 0.5rem;\r\n    right: 0.5rem;\r\n    top: 0.5rem;\r\n    z-index: 1050;\r\n    max-width: none;\r\n    flex: 1 1 auto;\r\n  }\r\n\r\n  .navbar-gs.is-expanded .navbar-gs-box {\r\n    width: 100%;\r\n    padding: 0 0.6rem;\r\n    justify-content: flex-start;\r\n    border-color: var(--accent);\r\n    background: var(--bg-input);\r\n  }\r\n\r\n  .navbar-gs.is-expanded .navbar-gs-input {\r\n    display: block;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
